import { storage } from '../firebase';
import { ref, getDownloadURL } from 'firebase/storage';

export async function getImageUrl(filePath: string): Promise<any> {
  const imageRef = ref(storage, filePath);
  if (!filePath) return;
  if (!imageRef) return;

  try {
    const url = await getDownloadURL(imageRef);
    return url;
  } catch (error) {
    console.log('Error getting document:', error);
    // Handle the error or throw it again based on your requirement
  }
}
